import {HomeMeasurementStatus} from "../../../list/found-measurement";

const visibleFor: (HomeMeasurementStatus | undefined)[] = [
  "MAILED_TO_PATIENT"
];

export function isFinishMeasuringButtonVisible(homeStatus: HomeMeasurementStatus | undefined) {
  return visibleFor.includes(homeStatus);
}
